/**
 * Datos de pago y ubicación de la clínica que ve el PACIENTE al agendar.
 *
 * Fuente de verdad del lado `src/` (UX_VISION P1-8). Consumido por: la pantalla de
 * éxito del booking (`BookingWizard.tsx`), el resumen del paso 3
 * (`PatientFormConfirmation.tsx`) y el selector de sede del flujo de paciente
 * existente (`ExistingPatientBooking.tsx`).
 *
 * Los valores están espejados 1:1 con el correo de confirmación al paciente
 * (`supabase/functions/send-email/templates/booking-confirmation-patient.ts`) — si
 * cambia uno, cambiar el otro. Los templates de email corren en Deno (Supabase Edge
 * Functions) y NO pueden importar desde `src/`, por eso la duplicación es inevitable
 * ahí; `booking-admin.ts` y `booking-confirmation-therapist.ts` también repiten los
 * datos bancarios a mano (deuda P2 — mover a una constante compartida en la carpeta
 * de las functions o a variables de entorno).
 */

/** Dirección de la oficina para consultas presenciales. */
export const CLINIC_OFFICE_ADDRESS = 'Bombero Adolfo Ossa 1010, Of. 204, Santiago';

/**
 * Pago presencial en la clínica (FUNC-127). Desde 2026-09 hay POS SumUp → además
 * de efectivo se acepta débito y crédito en persona.
 *
 * FUNC-131 (2026-10-06): el wizard público ofrece solo 2 opciones — 'transferencia'
 * (Transferencia / Efectivo, valor preferente) y 'tarjeta' (Débito / Crédito, precio
 * de lista). 'efectivo' ya no se declara desde el wizard; queda como valor legado en BD
 * (CHECK de `consultas.metodo_pago_declarado`): a nivel producto significa "pago en la clínica". El medio REAL (efectivo / débito /
 * crédito) se registra en `pagos.metodo_pago` cuando el terapeuta confirma el cobro.
 */
export const CLINIC_IN_PERSON_PAYMENT = {
  label: 'Pago en la clínica',
  medios: 'efectivo, débito o crédito',
  voucher: 'En la clínica (efectivo o tarjeta)',
} as const;

/** Datos de la cuenta para transferencia (mientras Transbank no está en producción). */
export const CLINIC_BANK_TRANSFER = {
  titular: 'Conectemos Spa',
  rut: '77.528.735-7',
  banco: 'Banco Santander',
  tipoCuenta: 'Cuenta Corriente',
  numeroCuenta: '0-000-9420593-0',
  comprobanteEmail: 'contacto@conectemoschile.cl',
  comprobanteWhatsapp: '+56 9 7800 9119',
} as const;
